module.exports = __webpack_public_path__ + "img/palier.e085ba53.jpg";